// @src/pre-deployment/src/components/shared/ContactLanding.js v1.0
// - Public page reached after scanning QR: loads then offers "Save contact" (vCard download).
// - No auth; inline feedback only (no alert/confirm).

import React, { useCallback, useState } from 'react';

// --- Edit your contact details here ---
const CONTACT = {
  firstName: 'Your',
  lastName: 'Name',
  phone: '+1234567890',
  email: 'you@example.com',
  org: 'Your Company',
  url: 'https://yoursite.com'
};

function buildVCard() {
  const n = `${CONTACT.lastName};${CONTACT.firstName};;;`;
  const fn = `${CONTACT.firstName} ${CONTACT.lastName}`;
  const lines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${n}`,
    `FN:${fn}`,
    `TEL;TYPE=CELL:${CONTACT.phone}`,
    `EMAIL:${CONTACT.email}`,
    `ORG:${CONTACT.org}`,
    `URL:${CONTACT.url}`,
    'END:VCARD'
  ];
  return lines.join('\r\n');
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f5f5f5',
    padding: '1rem',
    boxSizing: 'border-box'
  },
  card: {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    padding: '2rem',
    maxWidth: '360px',
    width: '100%'
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#1a1a1a',
    margin: '0 0 0.5rem 0'
  },
  sub: {
    fontSize: '13px',
    color: '#555',
    margin: '0 0 1.5rem 0'
  },
  btn: {
    width: '100%',
    padding: '0.75rem 1.25rem',
    fontSize: '1rem',
    fontWeight: 600,
    color: '#fff',
    background: '#1a1a1a',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer'
  },
  success: {
    fontSize: '13px',
    color: '#0a6b0a',
    margin: '1rem 0 0 0'
  },
  error: {
    fontSize: '13px',
    color: '#b00',
    margin: '1rem 0 0 0'
  }
};

function ContactLanding() {
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  const handleSaveContact = useCallback(() => {
    setError('');
    try {
      const vcard = buildVCard();
      const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'contact.vcf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setSaved(true);
    } catch (e) {
      setError(e.message || 'Could not save contact');
    }
  }, []);

  return (
    <div className="contact-landing" style={styles.page}>
      <div style={styles.card}>
        <p style={styles.title}>Add to contacts</p>
        <p style={styles.sub}>Tap below to save this contact to your phone.</p>
        <button
          type="button"
          className="contact-landing-save-btn"
          onClick={handleSaveContact}
          style={styles.btn}
        >
          Save contact
        </button>
        {saved && <p style={styles.success}>Contact file downloaded. Open it to add to your contacts.</p>}
        {error && <p style={styles.error}>{error}</p>}
      </div>
    </div>
  );
}

export default ContactLanding;
